import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Breadcrumb } from "@faire/retailer-visitor-shared/components/Breadcrumb/index";
import { brandPage } from "@faire/retailer-visitor-shared/paths/index";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
import * as React from "react";
export var ProductBasedCollectionBreadcrumb = function(param) {
    var collection = param.collection;
    var breadcrumbOptions = [];
    // Next the brand hosting the collection.
    if (collection.brand_name && collection.brand_token) {
        breadcrumbOptions.push({
            label: collection.brand_name,
            path: brandPage(collection.brand_token)
        });
    }
    // Lastly, the name of the collection.
    if (collection.name) {
        breadcrumbOptions.push({
            label: collection.name
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Breadcrumb, {
                options: breadcrumbOptions
            }),
            /*#__PURE__*/ _jsx(HorizontalLine, {})
        ]
    });
};
